// Only the Feather icons referenced somewhere in src/. FeatherIcon.vue looks icons up by
// name at runtime, and `import * as icons` would bundle all ~290 (~375 KB).
// When you use a new icon name, add it here (the FeatherIcon component warns in the
// console if a name is missing).
import {
  ActivityIcon,
  AlertCircleIcon,
  AlertOctagonIcon,
  AlertTriangleIcon,
  ArchiveIcon,
  ArrowDownCircleIcon,
  ArrowDownIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowUpIcon,
  AtSignIcon,
  BarChart2Icon,
  BellIcon,
  BellOffIcon,
  BookIcon,
  BookOpenIcon,
  BoxIcon,
  BriefcaseIcon,
  CalendarIcon,
  CheckCircleIcon,
  CheckIcon,
  CheckSquareIcon,
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  CircleIcon,
  ClipboardIcon,
  ClockIcon,
  CodepenIcon,
  CoffeeIcon,
  CornerUpRightIcon,
  DatabaseIcon,
  DollarSignIcon,
  DownloadIcon,
  Edit2Icon,
  Edit3Icon,
  EditIcon,
  ExternalLinkIcon,
  EyeIcon,
  EyeOffIcon,
  FacebookIcon,
  FeatherIcon,
  FileIcon,
  FileTextIcon,
  GitBranchIcon,
  GitCommitIcon,
  GithubIcon,
  GridIcon,
  HardDriveIcon,
  HashIcon,
  HomeIcon,
  ImageIcon,
  InboxIcon,
  InstagramIcon,
  LayersIcon,
  ListIcon,
  LockIcon,
  LogOutIcon,
  MapIcon,
  MapPinIcon,
  Maximize2Icon,
  MenuIcon,
  MessageCircleIcon,
  MinusIcon,
  MoreHorizontalIcon,
  MoonIcon,
  MoreVerticalIcon,
  PackageIcon,
  PaperclipIcon,
  PhoneIcon,
  PlusIcon,
  PrinterIcon,
  RefreshCcwIcon,
  RefreshCwIcon,
  RepeatIcon,
  RotateCwIcon,
  SaveIcon,
  SearchIcon,
  SendIcon,
  ServerIcon,
  SettingsIcon,
  ShieldIcon,
  ShoppingBagIcon,
  ShoppingCartIcon,
  SlackIcon,
  SunIcon,
  SlidersIcon,
  ToolIcon,
  Trash2Icon,
  TrashIcon,
  UploadCloudIcon,
  TrendingDownIcon,
  TrendingUpIcon,
  TruckIcon,
  TwitterIcon,
  UserIcon,
  UsersIcon,
  XCircleIcon,
  XIcon,
  ZapIcon,
  ZoomInIcon,
} from 'vue-feather-icons'

export default {
  ActivityIcon,
  AlertCircleIcon,
  AlertOctagonIcon,
  AlertTriangleIcon,
  ArchiveIcon,
  ArrowDownCircleIcon,
  ArrowDownIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowUpIcon,
  AtSignIcon,
  BarChart2Icon,
  BellIcon,
  BellOffIcon,
  BookIcon,
  BookOpenIcon,
  BoxIcon,
  BriefcaseIcon,
  CalendarIcon,
  CheckCircleIcon,
  CheckIcon,
  CheckSquareIcon,
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  CircleIcon,
  ClipboardIcon,
  ClockIcon,
  CodepenIcon,
  CoffeeIcon,
  CornerUpRightIcon,
  DatabaseIcon,
  DollarSignIcon,
  DownloadIcon,
  Edit2Icon,
  Edit3Icon,
  EditIcon,
  ExternalLinkIcon,
  EyeIcon,
  EyeOffIcon,
  FacebookIcon,
  FeatherIcon,
  FileIcon,
  FileTextIcon,
  GitBranchIcon,
  GitCommitIcon,
  GithubIcon,
  GridIcon,
  HardDriveIcon,
  HashIcon,
  HomeIcon,
  ImageIcon,
  InboxIcon,
  InstagramIcon,
  LayersIcon,
  ListIcon,
  LockIcon,
  LogOutIcon,
  MapIcon,
  MapPinIcon,
  Maximize2Icon,
  MenuIcon,
  MessageCircleIcon,
  MinusIcon,
  MoreHorizontalIcon,
  MoonIcon,
  MoreVerticalIcon,
  PackageIcon,
  PaperclipIcon,
  PhoneIcon,
  PlusIcon,
  PrinterIcon,
  RefreshCcwIcon,
  RefreshCwIcon,
  RepeatIcon,
  RotateCwIcon,
  SaveIcon,
  SearchIcon,
  SendIcon,
  ServerIcon,
  SettingsIcon,
  ShieldIcon,
  ShoppingBagIcon,
  ShoppingCartIcon,
  SlackIcon,
  SunIcon,
  SlidersIcon,
  ToolIcon,
  Trash2Icon,
  TrashIcon,
  UploadCloudIcon,
  TrendingDownIcon,
  TrendingUpIcon,
  TruckIcon,
  TwitterIcon,
  UserIcon,
  UsersIcon,
  XCircleIcon,
  XIcon,
  ZapIcon,
  ZoomInIcon,
}
